var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomkpiRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69634 12.8383C1.78767 11.9297 1.33301 11.475 1.33301 10.9103C1.33301 10.345 1.78767 9.89034 2.69634 8.98167L8.48167 3.19634C9.39101 2.28767 9.84501 1.83301 10.4103 1.83301C10.975 1.83301 11.4297 2.28767 12.3383 3.19634L13.303 4.16101C14.2117 5.06967 14.6663 5.52434 14.6663 6.08901C14.6663 6.65367 14.2117 7.10901 13.303 8.01767L7.51767 13.803C6.60834 14.7117 6.15301 15.1663 5.58901 15.1663C5.02501 15.1663 4.56967 14.7117 3.66101 13.803L2.69634 12.8383Z",
    stroke: "#6C757D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64245 6.14245L6.58645 7.08645M8.47112 3.31445L9.41379 4.25712M2.81445 8.97112L3.75712 9.91379M4.22845 7.55712L5.64312 8.97112M7.05712 4.72845L8.47112 6.14245",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomkpiRuler);
export default __webpack_public_path__ + "static/media/customkpi-ruler.c3e03fc510f48a1f4d1b2e2d23c21303.svg";
export { ForwardRef as ReactComponent };